import { useEffect } from "react";
import { toast } from "sonner";
import { canNotify, notifPermission, requestNotifyPermission } from "../lib/notify";

const ASKED_KEY = "emc_notif_asked";

// One-time, polite opt-in. Shows a dismissible toast asking to enable
// notifications for book-closing reminders & new capital requests.
export default function NotificationOptIn() {
  useEffect(() => {
    if (!canNotify() || notifPermission() !== "default") return;
    try { if (localStorage.getItem(ASKED_KEY) === "1") return; } catch { /* ignore */ }
    const t = setTimeout(() => {
      try { localStorage.setItem(ASKED_KEY, "1"); } catch { /* ignore */ }
      toast("Aktifkan notifikasi?", {
        description: "Dapatkan pengingat tutup buku & permintaan modal baru langsung di perangkat.",
        duration: 14000,
        action: {
          label: "Aktifkan",
          onClick: async () => {
            const perm = await requestNotifyPermission();
            if (perm === "granted") toast.success("Notifikasi aktif");
            else if (perm === "denied") toast.error("Izin notifikasi ditolak. Aktifkan dari pengaturan browser.");
          },
        },
      });
    }, 4000);
    return () => clearTimeout(t);
  }, []);
  return null;
}
